import { createLocalStorageHook } from '@/hooks/browser/createLocalStorageHook'
import { z } from 'zod'

export const useLockScreen = createLocalStorageHook('isLocked', z.boolean())
